import React from "react";
import {
  ComposedChart,
  Bar,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
} from "recharts";

// Label on top of bars (DLV)
const CustomBarLabel = ({ x, y, value }) => {
  if (x == null || y == null) return null;
  return (
    <text x={x + 22} y={y - 10} textAnchor="middle" fontSize={12} fill="#fff">
      {Number(value).toFixed(1)}%
    </text>
  );
};

// Dot + label for line (RTN). In v2.15 props expose `payload`, not `value`.
const CustomDot = ({ cx, cy, payload }) => {
  if (cx == null || cy == null) return null;
  const value = payload?.rtn;
  return (
    <g>
      <circle cx={cx} cy={cy} r={4} fill="#ffffff" stroke="#ddd" strokeWidth={2} />
      {/* place label above the dot to avoid clipping at chart bottom */}
      <text x={cx} y={cy - 10} textAnchor="middle" fontSize={12} fill="black">
        {value != null ? value.toFixed(1) : ""}%
      </text>
    </g>
  );
};

export default function DeliveryReturnChart({ deliveryReturnRatio : data}) {
  return (
    <div
      style={{
        width: "100%",
        height: "400px",
        background: "linear-gradient(to bottom, #666, #555)",
        borderRadius: "12px",
        padding: "16px",
      }}
    >
      {/* <h2
        style={{
          textAlign: "center",
          color: "#fff",
          fontSize: "18px",
          fontWeight: "bold",
          marginBottom: "12px",
        }}
      >
        Delivery v/s Return Ratio
      </h2> */}

      <ResponsiveContainer width="100%" height="100%">
        <ComposedChart
          data={data}
          margin={{ top: 30, right: 20, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="rgba(255,255,255,0.1)" />
          <XAxis dataKey="month" stroke="#fff" />
          <YAxis domain={[0, 100]} stroke="#fff" hide />
          <Tooltip formatter={(v) => `${Number(v).toFixed(1)}%`} />
          <Legend
            wrapperStyle={{ color: "#fff" }}
          />

          {/* DLV Bars */}
          <Bar
            dataKey="dlv"
            name="Delivered %"
            fill="url(#colorGradient)"
            barSize={50}
            radius={[5, 5, 0, 0]}
          >
            <LabelList dataKey="dlv" content={<CustomBarLabel />} />
          </Bar>

          {/* RTN Line */}
          {/* <Line
            type="monotone"
            dataKey="rtn"
            name="RTN %"
            stroke="#ddd"
            strokeWidth={3}
            dot={(props) => <CustomDot {...props} />}
            activeDot={{ r: 6, fill: "#ddd" }}
          /> */}

          {/* Gradient for bars */}
          <defs>
            <linearGradient id="colorGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#FF7C47" stopOpacity={1} />
              <stop offset="100%" stopColor="#FFB088" stopOpacity={1} />
            </linearGradient>
          </defs>
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}